<template>
  <v-dialog
    id="credits-dialog"
    v-model="open"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card max-height="100%" color="#D6B682" class="pa-3">
      <v-toolbar flat color="black">
        <v-toolbar-title class="bebas fdi-beige--text">Credits</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn color="#D6B682" flat left @click="closeCredits">
            close
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card color="#D6B682" class="prestige">
        <v-layout row>
          <v-flex xs12 my-4>
            <v-flex mt-3 ml-3>
              <v-flex>
                <p class="black--text subheading">Food Done It, LLC</p>
              </v-flex>
            </v-flex>

            <v-flex d-flex mx-4>
              <v-flex xs12>
                <p
                  class="black--text body-1 ml-3"
                >All Rights Reserved. All Stories, characters, logos, props, games, and puzzles are property of Food Done It, LLC and cannot be reproduced, distributed or used as source material for other content or products without prior written permission. It is not permitted to use extraction tools or tools to download parts of this website or the entire website or to store pages permanently</p>
              </v-flex>
            </v-flex>

            <v-flex d-flex mx-4>
              <v-flex xs4>
                <v-img :src="FDILogo"/>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-divider class="my-3" color="black"></v-divider>

        <v-layout row class="pb-4">
          <v-flex xs12>
            <v-flex d-flex mt-3 ml-3>
              <v-flex>
                <p class="black--text subheading">Dwyer Media Group</p>
              </v-flex>
            </v-flex>

            <v-flex d-flex mx-4>
              <v-flex xs12>
                <p
                  class="black--text body-1 ml-3"
                >All Rights Reserved. All Stories, characters, logos, props, games, and puzzles are property of Food Done It, LLC and cannot be reproduced, distributed or used as source material for other content or products without prior written permission. It is not permitted to use extraction tools or tools to download parts of this website or the entire website or to store pages permanently</p>
              </v-flex>
            </v-flex>

            <v-flex d-flex mx-4>
              <v-flex xs4>
                <v-img :src="DMGLogo"/>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import backButton from "@/assets/buttons/back-blk.png";
import FDILogo from "@/assets/logo_login_blk.png";
import DMGLogo from "@/assets/branding/DMG_logo.png";
export default {
  name: "credits-dialog",
  props: {
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      dialog: true,
      questions: [],
      backButton: backButton,
      FDILogo,
      DMGLogo
    };
  },
  methods: {
    closeCredits() {
      this.$store.dispatch("closeCredits");
    }
  },
  computed: {
    creditsDialog() {
      return this.$store.getters.creditsDialog;
    }
  }
};
</script>

<style>
</style>
